import React from 'react';
import { connect } from 'react-redux';
import getAccountNo from 'shared/utils/getAccountNo';
import getPlatformCode from 'shared/utils/getPlatformCode';
import socket from 'socket';
import { RootState } from 'store/types';
import { Nullable } from '../../../shared/global/types';

interface Props {
    accountNo: Nullable<number>
}

const TradeMasterHub = (props: Props) => {
    React.useEffect(() => {
        socket.createTradeMasterSocket();
        
        socket.tradeMaster.start()
        .then(() => changeSubscription())
        
        return (() => {
            socket.tradeMaster.close();
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.accountNo])

    const changeSubscription = () => {
        const platformCode = getPlatformCode();
        const accountNo = getAccountNo();
    
        const subscriptions = [platformCode + "_" + accountNo];
        socket.tradeMaster.update(subscriptions);
    }  

    return null;
}


const mapStateToProps = (state: RootState) => ({
    accountNo: state.account.accountNo,
})

export default connect(mapStateToProps)(TradeMasterHub);